/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type ETransportFreightPlutoDtoSource = typeof ETransportFreightPlutoDtoSource[keyof typeof ETransportFreightPlutoDtoSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ETransportFreightPlutoDtoSource = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
} as const;
